import React, { useEffect, useState } from 'react';

import * as z from 'zod';

import { useVerifyInvitation } from '../../hooks/tanstack/useOrganizationHook';
import {
  useCustomNavigate,
  useGetRouteParams,
} from '../../hooks/tanstack/useUtilsHook';
import OutlineLogo from '../../icons/OutlineLogo';
import routes from '../../routes';
import cn from '../../utils/cn';

import VerificationFailed from './VerificationFailed';

const CreateMemberSchema = z
  .object({
    email: z.string().trim().email('Invalid email address'),
    first_name: z.string().trim().min(1, 'This field is required'),
    last_name: z.string().trim().min(1, 'This field is required'),
    password: z
      .string()
      .trim()
      .min(8, 'Password must be at least 8 characters'),
    confirmPassword: z
      .string()
      .min(8, 'Confirm Password must be at least 8 characters'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Confirm password does not match',
    path: ['confirmPassword'],
  });

const InvitationVerification = () => {
  const [status, setStatus] = useState<'success' | 'pending' | 'failed' | null>(
    null
  );

  const navigate = useCustomNavigate();
  const { orgId, token, invitationId } = useGetRouteParams();

  const { mutate: verifyInvitation } = useVerifyInvitation({
    onSuccess: (data) => {
      localStorage.setItem(
        'user',
        JSON.stringify({
          id: data.user.id,
        })
      );

      navigate(routes.projects.index, {
        org_id: orgId,
      });
    },
    onError: (error) => {
      setStatus('failed');
    },
  });

  useEffect(() => {
    setStatus('pending');
  }, []);

  useEffect(() => {
    if (orgId && token && invitationId && status === 'pending') {
      verifyInvitation({
        orgId,
        invitationId,
        data: {
          token,
        },
      });
    }
  }, [orgId, token, invitationId, status]);

  return (
    <div className={cn('space-y-4 bg-primary-dark-blue h-screen')}>
      <div className="text-white flex bg-primary-dark-blue py-7 px-[90px] items-center justify-start gap-3">
        <OutlineLogo />
        <p className="text-[22px] font-bold">ISBE Group</p>
      </div>
      <div>{status === 'failed' && <VerificationFailed />}</div>
    </div>
  );
};

export default InvitationVerification;
